export default "__VITE_ASSET__BRvPOmhM__"